<div class="page-content">
  <app-page-header [headline]="'SIDEBAR.OVERVIEW'">
  </app-page-header>

  <div class="page-scroll-content">
    @if (hasSpaces) {
      <div class="content-card">
        <app-spaces-overview [spaces]="spaces" (viewDetails)="onViewDetails($event)"></app-spaces-overview>
      </div>
    } @else {
      <div class="empty-state-card">
        <p class="empty-message">{{ 'SPACES_PAGE.EMPTY_MESSAGE' | translate }}</p>
      </div>
    }
  </div>
</div>
